import type { Ref } from 'vue'
import Plotly from 'plotly.js-dist'
import type { LegendClickEvent, PlotData, PlotlyHTMLElement } from 'plotly.js'

export const onLegendClicked = (plotlyChart: Ref<PlotlyHTMLElement | null>) => {
  if (plotlyChart.value) {
    plotlyChart.value.on('plotly_legendclick', function (data: LegendClickEvent): boolean {
      if (!data.curveNumber) return false
      const clickedTraceName = data.data[data.curveNumber]?.name
      const updatedVisibility: ('legendonly' | boolean)[] = data.data.map((trace) => {
        trace = trace as PlotData
        if (trace.name === clickedTraceName) {
          return trace.visible === 'legendonly' ? true : 'legendonly'
        }
        return trace.visible || true
      })
      if (plotlyChart.value) {
        Plotly.restyle(plotlyChart.value, { visible: updatedVisibility } as any)
      }
      return false
    })
  }
}
